import React from "react";
import {
  BackHeader,
  MostPopularCoursesNavbar,
  SideMenu,
  Model,
} from "./../../components";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CoverImage from "./../../../assets/images/profileHeader.png";
import { GrFacebookOption, GrTwitter } from "react-icons/gr";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { MdOutlineLocationOn } from "react-icons/md";
import { Button } from "@mui/material";
import { IoMdCall } from "react-icons/io";
import EventVenueIcon from "./../../../assets/svg/eventVenueIcon.svg";
import { useLocation } from "react-router-dom";
import { useAlert } from "react-alert";
import Countries from "./../../../data/countries";
const UpcommingEventsDetails = () => {
  const alert = useAlert();
  const navigate = useNavigate();
  const location = useLocation();
  const [registerForm, setRegisterForm] = React.useState(false);
  const [countryCode, setCountryCode] = React.useState("");
  const [selectedCountryCode, setSelectedCountryCode] = React.useState();
  const handleDropdownChange = (e) => {
    setCountryCode(e.target.value);
    Countries.map((v, i) => {
      if (Countries[i].alpha2Code === e.target.value) {
        setSelectedCountryCode(Countries[i].callingCode);
      }
    });
  };
  // Register Form
  const [registerFirstName, setRegisterFirstName] = React.useState("");
  const [registerLastName, setRegisterLastName] = React.useState("");
  const [registerEmail, setRegisterEmail] = React.useState("");
  const [registerMobileNumber, setRegisterMobileNumber] = React.useState("");
  const [registerLoading, setRegisterLoading] = React.useState(false);
  const registerFirstNameRef = React.useRef();
  const registerLastNameRef = React.useRef();
  const registerEmailRef = React.useRef();
  const registerCountryCodeRef = React.useRef();
  const registerMobileNumberRef = React.useRef();
  const RegisterFormHandler = () => {
    if (registerFirstName === "") {
      alert.error(<div className="alert-message">first name required</div>);
      registerFirstNameRef.current.focus();
    } else if (registerLastName === "") {
      alert.error(<div className="alert-message">last name required</div>);
      registerLastNameRef.current.focus();
    } else if (registerEmail === "") {
      alert.error(
        <div className="alert-message">please enter email address</div>
      );
      registerEmailRef.current.focus();
    } else if (countryCode === "") {
      alert.error(
        <div className="alert-message">please select country code</div>
      );
      registerCountryCodeRef.current.focus();
    } else if (registerMobileNumber === "") {
      alert.error(
        <div className="alert-message">please enter valid mobile number</div>
      );
      registerMobileNumberRef.current.focus();
    } else {
      setRegisterLoading(true);
      const RegisterObject = {
        firstName: registerFirstName,
        lastName: registerLastName,
        email: registerEmail,
        countryCode: selectedCountryCode,
        mobileNumber: registerMobileNumber,
      };
      alert.success(
        <div className="alert-message">
          you have successfully register the events
        </div>
      );
      console.log(RegisterObject);
      setTimeout(() => {
        setRegisterForm(false);
        setRegisterLoading(false);
      }, 2000);
    }
  };
  return (
    <div>
      {location.state.type === "unauthorized" ? (
        <div>
          <MostPopularCoursesNavbar />
          <div className="page-details-container">
            <BackHeader backHanler={() => navigate(-1)} />
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}></Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12}></Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
                  <Button className="header-button" variant="text">
                    <p className="page-header-button-text">Download</p>
                  </Button>
                </Grid>

                <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                  <Button
                    className="header-button"
                    variant="text"
                    onClick={() => setRegisterForm(true)}
                  >
                    <p className="page-header-button-text">Register Now</p>
                  </Button>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xl={10} lg={10} md={10} sm={12} xs={12}>
                  <p className="data-view-heading">
                    Lorem ipsum dolor sit amet
                  </p>
                  <div className="card-location-main">
                    <MdOutlineLocationOn color="#663399" />

                    <p className="card-location">burnside</p>
                  </div>
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={12} xs={12}></Grid>
              </Grid>
            </Box>

            <img src={CoverImage} className="data-view-header-cover-image" />
            <div className="data-view-cover-footer-container">
              <div className="data-view-cover-footer">
                <p className="data-view-cover-footer-date">14 march 2022</p>
              </div>
              <p className="data-view-cover-footer-data">$2000</p>
            </div>
            <div className="data-view-cover-footer-container">
              <div>
                <p className="data-view-cover-footer-data">
                  Tutor name: Willow Anderson
                </p>
                <p className="icon-heading">willowAnderson@gmail.com</p>
              </div>

              <div className="heading-main">
                <IoMdCall color="#000" size={30} />
                <p className="data-view-cover-footer-data">+971 1234567890</p>
              </div>
            </div>
            <div className="data-view-cover-footer-container">
              <div className="data-view-cover-footer">
                <p className="data-view-cover-footer-date"></p>
              </div>
              <div className="share-main">
                <p className="data-view-cover-footer-data">share</p>
                <div>
                  <button className="share-button">
                    <GrFacebookOption color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaLinkedinIn color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <GrTwitter color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaWhatsapp color="white" size={20} />
                  </button>
                </div>
              </div>
            </div>
            <p className="description-heading">Discription</p>
            <p className="data-view-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
              lorem congue, euismod urna vitae, porttitor mi. Aliquam
              consectetur eu turpis ac congue. <br /> <br />
              Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
              accumsan. Ut eget elementum sem. Sed et nibh pharetra. Lorem ipsum
              dolor sit amet, consectetur adipiscing elit. In in lorem congue,
              euismod urna vitae, porttitor mi. Aliquam consectetur eu turpis ac
              congue. <br /> <br />
              Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
              accumsan. Ut eget elementum sem. Sed et nibh pharetra. <br />{" "}
              <br />
              Fusce non porttitor mi. Pellentesque lacus tortor, placerat sit
              amet condimentum eu, placerat id urna. Nunc tellus purus,
              porttitor vel faucibus at, sagittis eget neque. Vivamus quis magna
              est. Pellentesque in finibus turpis, eget feugiat leo. In
              ullamcorper maximus magna non fringilla. <br /> <br />
              Morbi ante dui, pulvinar vitae urna eu, pretium pretium nulla.
              Praesent ultricies sapien vitae sapien lacinia facilisis. Nam in
              ipsum id nibh mollis semper sit amet in erat. Suspendisse finibus
              placerat eros id interdum. Curabitur mattis augue erat, ut posuere
              nisi molestie sed. <br /> <br />
              Fusce vel arcu a nisl viverra rhoncus. Donec vel sagittis lacus.
              Sed id quam et quam malesuada dignissim sit amet eu massa. Aenean
              euismod orci eu sem volutpat, vitae consequat nulla fringilla.{" "}
              <br /> <br />
              Curabitur massa sem, ullamcorper rhoncus euismod at, luctus vel
              velit. Fusce neque felis, vehicula sit amet massa eu, euismod
              tempor nulla. Duis iaculis orci ut euismod venenatis. Vestibulum
              eu sem id tortor mollis mollis blandit tristique eros. Nam
              pulvinar ultricies arcu at fermentum.
            </p>
            <div className="data-view-card-main">
              <p className="data-view-card-title">Event Venue</p>
            </div>
            <div className="data-view-card-list-main">
              <div>
                <p className="data-view-card-list-heading">Burnside</p>
                <p className="data-view-card-list-description">
                  Tavern, Plot 108, Rambaug Colony, MIT Road, Kothrud, burnside
                </p>
              </div>
              <div className="data-view-card-list-icon">
                <img src={EventVenueIcon} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SideMenu>
          <div className="page-details-container">
            <BackHeader backHanler={() => navigate(-1)} />
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}></Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12}></Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
                  <Button className="header-button" variant="text">
                    <p className="page-header-button-text">Download</p>
                  </Button>
                </Grid>

                <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                  <Button
                    className="header-button"
                    variant="text"
                    onClick={() => setRegisterForm(true)}
                  >
                    <p className="page-header-button-text">Register Now</p>
                  </Button>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xl={10} lg={10} md={10} sm={12} xs={12}>
                  <p className="data-view-heading">
                    Lorem ipsum dolor sit amet
                  </p>
                  <div className="card-location-main">
                    <MdOutlineLocationOn color="#663399" />

                    <p className="card-location">burnside</p>
                  </div>
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={12} xs={12}></Grid>
              </Grid>
            </Box>

            <img src={CoverImage} className="data-view-header-cover-image" />
            <div className="data-view-cover-footer-container">
              <div className="data-view-cover-footer">
                <p className="data-view-cover-footer-date">14 march 2022</p>
              </div>
              <p className="data-view-cover-footer-data">$2000</p>
            </div>
            <div className="data-view-cover-footer-container">
              <div>
                <p className="data-view-cover-footer-data">
                  Tutor name: Willow Anderson
                </p>
                <p className="icon-heading">willowAnderson@gmail.com</p>
              </div>

              <div className="heading-main">
                <IoMdCall color="#000" size={30} />
                <p className="data-view-cover-footer-data">+971 1234567890</p>
              </div>
            </div>
            <div className="data-view-cover-footer-container">
              <div className="data-view-cover-footer">
                <p className="data-view-cover-footer-date"></p>
              </div>
              <div className="share-main">
                <p className="data-view-cover-footer-data">share</p>
                <div>
                  <button className="share-button">
                    <GrFacebookOption color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaLinkedinIn color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <GrTwitter color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaWhatsapp color="white" size={20} />
                  </button>
                </div>
              </div>
            </div>
            <p className="description-heading">Discription</p>
            <p className="data-view-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
              lorem congue, euismod urna vitae, porttitor mi. Aliquam
              consectetur eu turpis ac congue. <br /> <br />
              Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
              accumsan. Ut eget elementum sem. Sed et nibh pharetra. Lorem ipsum
              dolor sit amet, consectetur adipiscing elit. In in lorem congue,
              euismod urna vitae, porttitor mi. Aliquam consectetur eu turpis ac
              congue. <br /> <br />
              Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
              accumsan. Ut eget elementum sem. Sed et nibh pharetra. <br />{" "}
              <br />
              Fusce non porttitor mi. Pellentesque lacus tortor, placerat sit
              amet condimentum eu, placerat id urna. Nunc tellus purus,
              porttitor vel faucibus at, sagittis eget neque. Vivamus quis magna
              est. Pellentesque in finibus turpis, eget feugiat leo. In
              ullamcorper maximus magna non fringilla. <br /> <br />
              Morbi ante dui, pulvinar vitae urna eu, pretium pretium nulla.
              Praesent ultricies sapien vitae sapien lacinia facilisis. Nam in
              ipsum id nibh mollis semper sit amet in erat. Suspendisse finibus
              placerat eros id interdum. Curabitur mattis augue erat, ut posuere
              nisi molestie sed. <br /> <br />
              Fusce vel arcu a nisl viverra rhoncus. Donec vel sagittis lacus.
              Sed id quam et quam malesuada dignissim sit amet eu massa. Aenean
              euismod orci eu sem volutpat, vitae consequat nulla fringilla.{" "}
              <br /> <br />
              Curabitur massa sem, ullamcorper rhoncus euismod at, luctus vel
              velit. Fusce neque felis, vehicula sit amet massa eu, euismod
              tempor nulla. Duis iaculis orci ut euismod venenatis. Vestibulum
              eu sem id tortor mollis mollis blandit tristique eros. Nam
              pulvinar ultricies arcu at fermentum.
            </p>
            <div className="data-view-card-main">
              <p className="data-view-card-title">Event Venue</p>
            </div>
            <div className="data-view-card-list-main">
              <div>
                <p className="data-view-card-list-heading">Burnside</p>
                <p className="data-view-card-list-description">
                  Tavern, Plot 108, Rambaug Colony, MIT Road, Kothrud, burnside
                </p>
              </div>
              <div className="data-view-card-list-icon">
                <img src={EventVenueIcon} />
              </div>
            </div>
          </div>
        </SideMenu>
      )}
      <Model
        modelTitle="Register Now"
        onClose={() => setRegisterForm(false)}
        open={registerForm}
        buttonTitle="Register"
        buttonHandler={RegisterFormHandler}
        loading={registerLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">First name</p>
                  <input
                    type="text"
                    name="firstName"
                    className="input"
                    placeholder="Name"
                    value={registerFirstName}
                    ref={registerFirstNameRef}
                    onChange={(e) => setRegisterFirstName(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Last name</p>
                  <input
                    type="text"
                    name="lastName"
                    className="input"
                    placeholder="Name"
                    value={registerLastName}
                    ref={registerLastNameRef}
                    onChange={(e) => setRegisterLastName(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Email Address</p>
                  <input
                    type="email"
                    name="email"
                    required="required"
                    className="input"
                    placeholder="Email Address"
                    value={registerEmail}
                    ref={registerEmailRef}
                    onChange={(e) => setRegisterEmail(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Mobile Number</p>
                  <div className="country-code-picker-main">
                    <div className="country-code-picker-dropdown-main">
                      <select
                        className="country-code-picker-dropdown"
                        ref={registerCountryCodeRef}
                        onChange={handleDropdownChange}
                      >
                        <option value="">Select</option>
                        {Countries.map((countriesValue, countriesIndex) => {
                          return (
                            <option
                              key={countriesIndex}
                              value={countriesValue.alpha2Code}
                            >
                              {`${countriesValue.callingCode}  ${countriesValue.name}`}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="country-flag-main">
                      {Countries.map(
                        (countriesFlagValue, countriesFlagIndex) => {
                          return (
                            <div key={countriesFlagIndex}>
                              {countriesFlagValue.alpha2Code ===
                                countryCode && (
                                <img
                                  src={countriesFlagValue.flag}
                                  className="country-flag"
                                />
                              )}
                            </div>
                          );
                        }
                      )}
                      <input
                        type="number"
                        name="mobileNumber"
                        className="mobile-number-input"
                        placeholder="Enter your mobile number"
                        value={registerMobileNumber}
                        ref={registerMobileNumberRef}
                        onChange={(e) =>
                          setRegisterMobileNumber(e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </div>
  );
};
export default UpcommingEventsDetails;
